import React from 'react'
import ScheduleAirtimeExcel from './ScheduleAirtimeExcel'
import ScheduleDataExcel from './ScheduleDataExcel'

const ScheduleViaExcel = () => {
  return (
    <div className="mx-auto p-4">
      {/* tabs */}
      <div role="tablist" className="tabs tabs-bordered mt-2">
        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Schedule Airtime" defaultChecked />
        <div role="tabpanel" className="tab-content py-4 overflow-hidden">
          <ScheduleAirtimeExcel />
        </div>

        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Schedule Data" />
        <div role="tabpanel" className="tab-content py-4">
          <ScheduleDataExcel />
        </div>
      </div>
    </div>
  )
}

export default ScheduleViaExcel
